
import { useQuery } from "react-query";
import axios from "axios";
import { useState } from "react";
import "./registerconfirm.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint } from "../components/utils";
import { pageIds } from "../components/utils";


interface PageResponse {
  headerTitle?: string;
  welcomeMessage?: any;
}

const RegisterConfirm = () => {
  const [data, setdata] = useState<PageResponse | null>();
  const { isLoading, error } = useQuery("registerPageData", async () => {
    const resp = await axios.get(ApiEndpoint + "wp-json/firstchoiceprep/v1/getPageText?slug=" + pageIds.register_confirm);
    setdata(resp.data as PageResponse);
  });

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <div className="registerConfirmPage">
        <div className="headline">
            <h1>{data?.headerTitle}</h1>
            <div className="description" dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }} />
        </div>
    </div>
    );
};

export default RegisterConfirm;
